import React from 'react'

interface IProps {
  children?: any
}

export function SkPageListBody(props: IProps) {
  return <div className="px-3 md:px-6">{props.children}</div>
}
